import React from 'react';
import { withCookies } from 'react-cookie';

import Logo from '../../assets/logos/lucastswick-generative-artist-logo-white.png';
// import PatternImage1 from '../../assets/patterns/pattern-1.png';
import PatternImage2 from '../../assets/patterns/pattern-2.png';
import PatternImage3 from '../../assets/patterns/pattern-3.png';
import PatternImage4 from '../../assets/patterns/pattern-4.png';
import PatternImage5 from '../../assets/patterns/pattern-5.png';
import { marquee, logoWrapper, logoRule, containerRule } from './styles';

class Marquee extends React.Component {
  constructor(props) {
    super(props);

    this.initComplete = false;

    const { cookies } = props;
    let visitCount = parseInt(cookies.get('visitCount'), 10) || 0;
    visitCount += 1;

    cookies.set('visitCount', visitCount);

    this.state = {
      threeReady: false,
      visitCount: visitCount,
    };
  }

  componentDidMount() {
    if (window.THREE) {
      this.setState({
        threeReady: true,
      });
      return;
    }

    if (!this.state.threeReady && !window.THREE) {
      const script = document.createElement('script');
      script.src =
        'https://cdnjs.cloudflare.com/ajax/libs/three.js/91/three.min.js';
      document.body.appendChild(script);

      const scripts = [
        '/assets/lib/OrbitControls.js',
        '/assets/lib/BufferGeometryUtils.js',
        '/assets/lib/NormalMapShader.js',
        '/assets/lib/ShaderTerrain.js',
        '/assets/lib/SVGLoader.js',
        '/assets/lib/Detector.js',
        '/assets/lib/stats.min.js',
      ];

      this.intervalId = setInterval(() => {
        if (window && window.THREE) {
          scripts.map((s) => {
            const script = document.createElement('script');
            script.src = s;
            document.body.appendChild(script);
            return true;
          });
          if (
            window.THREE &&
            window.THREE.OrbitControls &&
            window.THREE.BufferGeometryUtils &&
            window.THREE.NormalMapShader &&
            window.THREE.ShaderTerrain &&
            window.THREE.SVGLoader &&
            window.Detector &&
            window.Stats &&
            window.theme
          ) {
            this.setState(
              {
                threeReady: true,
              },
              () => {
                clearInterval(this.intervalId);
              },
            );
          }
        }
      }, 1000);
    }
  }

  componentWillUnmount() {
    clearInterval(this.intervalId);
    document.getElementById('vertexShader').remove();
    document.getElementById('fragmentShaderNoise').remove();

    // clean up
    // scene.remove( mesh );
    // geometry.dispose();
    // material.dispose();
    // texture.dispose();
  }

  renderFragmentScript() {
    return (
      <script
        id="fragmentShaderNoise"
        type="x-shader/x-fragment"
        dangerouslySetInnerHTML={{
          __html: `
        //
        // Description : Array and textureless GLSL 3D simplex noise function.
        //      Author : Ian McEwan, Ashima Arts.
        //  Maintainer : ijm
        //     Lastmod : 20110409 (stegu)
        //     License : Copyright (C) 2011 Ashima Arts. All rights reserved.
        //               Distributed under the MIT License. See LICENSE file.
        //

        uniform float time;
        varying vec2 vUv;

        vec4 permute( vec4 x ) {

          return mod( ( ( x * 34.0 ) + 1.0 ) * x, 289.0 );

        }

        vec4 taylorInvSqrt( vec4 r ) {

          return 1.79284291400159 - 0.85373472095314 * r;

        }

        float snoise( vec3 v ) {

          const vec2 C = vec2( 1.0 / 6.0, 1.0 / 3.0 );
          const vec4 D = vec4( 0.0, 0.5, 1.0, 2.0 );

          // First corner

          vec3 i  = floor( v + dot( v, C.yyy ) );
          vec3 x0 = v - i + dot( i, C.xxx );

          // Other corners

          vec3 g = step( x0.yzx, x0.xyz );
          vec3 l = 1.0 - g;
          vec3 i1 = min( g.xyz, l.zxy );
          vec3 i2 = max( g.xyz, l.zxy );

          vec3 x1 = x0 - i1 + 1.0 * C.xxx;
          vec3 x2 = x0 - i2 + 2.0 * C.xxx;
          vec3 x3 = x0 - 1. + 3.0 * C.xxx;

          // Permutations

          i = mod( i, 289.0 );
          vec4 p = permute( permute( permute(
               i.z + vec4( 0.0, i1.z, i2.z, 1.0 ) )
               + i.y + vec4( 0.0, i1.y, i2.y, 1.0 ) )
               + i.x + vec4( 0.0, i1.x, i2.x, 1.0 ) );

          // Gradients
          // ( N*N points uniformly over a square, mapped onto an octahedron.)

          float n_ = 1.0 / 7.0; // N=7

          vec3 ns = n_ * D.wyz - D.xzx;

          vec4 j = p - 49.0 * floor( p * ns.z *ns.z );  //  mod(p,N*N)

          vec4 x_ = floor( j * ns.z );
          vec4 y_ = floor( j - 7.0 * x_ );    // mod(j,N)

          vec4 x = x_ *ns.x + ns.yyyy;
          vec4 y = y_ *ns.x + ns.yyyy;
          vec4 h = 1.0 - abs( x ) - abs( y );

          vec4 b0 = vec4( x.xy, y.xy );
          vec4 b1 = vec4( x.zw, y.zw );


          vec4 s0 = floor( b0 ) * 2.0 + 1.0;
          vec4 s1 = floor( b1 ) * 2.0 + 1.0;
          vec4 sh = -step( h, vec4( 0.0 ) );

          vec4 a0 = b0.xzyw + s0.xzyw * sh.xxyy;
          vec4 a1 = b1.xzyw + s1.xzyw * sh.zzww;

          vec3 p0 = vec3( a0.xy, h.x );
          vec3 p1 = vec3( a0.zw, h.y );
          vec3 p2 = vec3( a1.xy, h.z );
          vec3 p3 = vec3( a1.zw, h.w );

          // Normalise gradients

          vec4 norm = taylorInvSqrt( vec4( dot( p0, p0 ), dot( p1, p1 ), dot( p2, p2 ), dot( p3, p3 ) ) );
          p0 *= norm.x;
          p1 *= norm.y;
          p2 *= norm.z;
          p3 *= norm.w;

          // Mix final noise value

          vec4 m = max( 0.6 - vec4( dot( x0, x0 ), dot( x1, x1 ), dot( x2, x2 ), dot( x3, x3 ) ), 0.0 );
          m = m * m;
          return 42.0 * dot( m*m, vec4( dot( p0, x0 ), dot( p1, x1 ),
                          dot( p2, x2 ), dot( p3, x3 ) ) );

        }

        float surface3( vec3 coord ) {

          float n = 0.0;

          n += 1.0 * abs( snoise( coord ) );
          n += 0.5 * abs( snoise( coord * 2.0 ) );
          n += 0.25 * abs( snoise( coord * 4.0 ) );
          n += 0.125 * abs( snoise( coord * 8.0 ) );

          return n;

        }

        void main( void ) {

          vec3 coord = vec3( vUv, -time );
          float n = surface3( coord );

          gl_FragColor = vec4( vec3( n, n, n ), 1.0 );

        }
      `,
        }}
      />
    );
  }

  renderVertexScript() {
    return (
      <script
        id="vertexShader"
        type="x-shader/x-vertex"
        dangerouslySetInnerHTML={{
          __html: `
        varying vec2 vUv;
        uniform vec2 scale;
        uniform vec2 offset;

        void main( void ) {

          vUv = uv * scale + offset;
          gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );

        }
      `,
        }}
      />
    );
  }

  initThree = () => {
    if (this.initComplete) {
      return;
    }
    const THREE = window.THREE;
    const Detector = window.Detector;

    if (!Detector.webgl) {
      // Detector.addGetWebGLMessage();
      return;
    }

    var SCREEN_WIDTH = window.innerWidth;
    var SCREEN_HEIGHT = window.innerHeight - 150;

    var renderer, container;
    // var stats;
    // var controls;

    var camera, scene;
    var cameraOrtho, sceneRenderTarget;

    var uniformsNoise,
      uniformsNormal,
      uniformsTerrain,
      heightMap,
      normalMap,
      quadTarget;

    var directionalLight, pointLight;

    var terrain, logoSprite;

    var animDelta = 0,
      animDeltaDir = 1;
    var lightVal = 0,
      lightDir = 1;

    var clock = new THREE.Clock();

    var updateNoise = true;

    // var animateTerrain = true;

    var scale, newScale;

    var mlib = {};

    const { visitCount } = this.state;
    var settings = randomizeSettings(visitCount);
    init(visitCount);
    animate();

    function randomizeSettings(visitCount) {
      // const primaryColor = new THREE.Color().setHSL(
      //   0.5 + Math.random() * 0.5,
      //   0.3,
      //   0.5
      // );
      // var p2 = new complimentaryColors('#' + primaryColor.getHexString());
      // const background = new THREE.Color(4, 4, 4);

      const primaryColor = new THREE.Color(window.theme.marqueeColors[0]);
      const secondaryColor = new THREE.Color(window.theme.marqueeColors[1]);
      const tertiaryColor = new THREE.Color(0xffffff);

      // const background = new THREE.Color(primaryColor.getHSL({}).h, 0.5, 0.8);
      const background = new THREE.Color(
        window.theme.marqueeColors[window.theme.marqueeColors.lenth - 1],
      );
      // const secondaryColor = new THREE.Color((primaryColor.getHSL().h + Math.random() * .1) % 1, 0.3, 0.5)
      // const secondaryColor = p2.triad()[1];
      // const tertiaryColor = p2.triad()[2];

      // const pattern = `/assets/pattern-${Math.ceil(Math.random() * 4) }.png`
      const patterns = [
        // PatternImage1,
        PatternImage2,
        PatternImage3,
        PatternImage4,
        PatternImage5,
      ];
      let pattern = patterns[visitCount % patterns.length];

      return {
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        tertiaryColor: tertiaryColor,
        background: background,
        pattern: pattern,
      };
    }

    function init(visitCount) {
      var logoElement = document.getElementById('lucastswick-logo');
      logoElement.classList.add('fade-out');

      container = document.getElementById('container');
      container.classList.add('fade-in');

      // SCENE (RENDER TARGET)

      sceneRenderTarget = new THREE.Scene();

      cameraOrtho = new THREE.OrthographicCamera(
        SCREEN_WIDTH / -2,
        SCREEN_WIDTH / 2,
        SCREEN_HEIGHT / 2,
        SCREEN_HEIGHT / -2,
        -10000,
        10000,
      );
      cameraOrtho.position.z = 100;

      sceneRenderTarget.add(cameraOrtho);

      // CAMERA

      camera = new THREE.PerspectiveCamera(
        40,
        SCREEN_WIDTH / SCREEN_HEIGHT,
        2,
        4000,
      );
      // camera.position.set( -1200, 800, 1200 );
      camera.position.set(
        -1706.8533148944814,
        2143.5675967145926,
        1775.015372748465,
      );
      camera.rotation.set(
        -0.8791747245082203,
        -0.550138252670274,
        -0.5631574511473713,
      );

      // controls = new THREE.OrbitControls( camera );

      // controls.rotateSpeed = 0.3;
      // controls.zoomSpeed = 1.2;
      // controls.panSpeed = 0.8;
      // // controls.autoRotate = true;
      // controls.enableKeys = false;
      // controls.enableZoom = false;

      // controls.keys = [ 65, 83, 68 ];

      // SCENE (FINAL)

      scene = new THREE.Scene();
      // scene.background = new THREE.Color( 0x050505 );
      // scene.fog = new THREE.Fog( 0x050505, 2000, 4000 );
      scene.background = settings.background;
      scene.fog = new THREE.Fog(settings.background, 2000, 4000);

      // LIGHTS
      // const col = (new Date().getHours() / 24 * 256) >> 0x0000;
      // const col = new THREE.Color().setHSL(new Date().getHours() / 24, 0.3, 0.5);
      // const col = new THREE.Color().setHSL(Math.random() * 256, 0.3, 0.5);
      // const ambientLight = new THREE.AmbientLight( settings.primaryColor )
      scene.add(new THREE.AmbientLight(settings.primaryColor));

      // directionalLight = new THREE.DirectionalLight( 0xffffff, 1.15 );
      directionalLight = new THREE.DirectionalLight(
        settings.secondaryColor,
        1.15,
      );
      directionalLight.position.set(500, 2000, 0);
      scene.add(directionalLight);

      // pointLight = new THREE.PointLight( 0xff4400, 1.5 );
      pointLight = new THREE.PointLight(settings.tertiaryColor, 0.5);
      pointLight.position.set(0, 0, 0);
      scene.add(pointLight);

      // HEIGHT + NORMAL MAPS

      var normalShader = THREE.NormalMapShader;

      var rx = 256,
        ry = 256;
      var pars = {
        minFilter: THREE.LinearFilter,
        magFilter: THREE.LinearFilter,
        format: THREE.RGBFormat,
      };

      heightMap = new THREE.WebGLRenderTarget(rx, ry, pars);
      heightMap.texture.generateMipmaps = false;

      normalMap = new THREE.WebGLRenderTarget(rx, ry, pars);
      normalMap.texture.generateMipmaps = false;

      scale = Math.random() * 3 + 1;
      newScale = scale;

      uniformsNoise = {
        time: { value: Math.random() },
        scale: { value: new THREE.Vector2(scale, scale) },
        offset: { value: new THREE.Vector2(0, 0) },
      };

      uniformsNormal = THREE.UniformsUtils.clone(normalShader.uniforms);

      uniformsNormal.height.value = 0.05;
      uniformsNormal.resolution.value.set(rx, ry);
      uniformsNormal.heightMap.value = heightMap.texture;

      var vertexShader = document.getElementById('vertexShader').textContent;

      // TEXTURES
      var logoSpriteMap = new THREE.TextureLoader().load(Logo);
      // "./assets/logos/lucastswick-generative-artist-logo-white.png"
      // );

      var logoSpriteMaterial = new THREE.SpriteMaterial({
        map: logoSpriteMap,
        color: 0xffffff,
        transparent: true,
        lights: true,
        fog: true,
      });

      logoSprite = new THREE.Sprite(logoSpriteMaterial);
      logoSprite.scale.set(960, 960, 1);
      logoSprite.position.set(0, 960, 960);

      scene.add(logoSprite);

      var loadingManager = new THREE.LoadingManager(function () {
        terrain.visible = true;
      });
      var textureLoader = new THREE.TextureLoader(loadingManager);

      var specularMap = new THREE.WebGLRenderTarget(2048, 2048, pars);
      specularMap.texture.generateMipmaps = false;

      const canvas = document.createElement('canvas');
      canvas.width = 128;
      canvas.height = 128;
      var diffuseTexture1 = new THREE.Texture(canvas);
      diffuseTexture1.needsUpdate = true;

      // var diffuseTexture1 = textureLoader.load( '/assets/pattern-2.png' );
      var diffuseTexture2 = textureLoader.load(settings.pattern);
      // var diffuseTexture2 = textureLoader.load( 'https://instagram.fsnc1-1.fna.fbcdn.net/vp/6e67818b4edda038ea8f2dbe67a5fdf3/5B2BEDCA/t51.2885-15/s150x150/e35/19120310_315059175598157_7903694535740358656_n.jpg' );
      // var diffuseTexture2 = textureLoader.load( 'https://instagram.fsnc1-1.fna.fbcdn.net/vp/25785d6d5ee6ea5108e56461dd61d6c0/5B3DEEBA/t51.2885-15/s640x640/sh0.08/e35/16465736_221866371617183_1673817539152445440_n.jpg' );
      // var detailTexture = textureLoader.load( '/assets/loneliness.png' );

      diffuseTexture1.wrapS = diffuseTexture1.wrapT = THREE.RepeatWrapping;
      diffuseTexture2.wrapS = diffuseTexture2.wrapT = THREE.RepeatWrapping;
      // detailTexture.wrapS = detailTexture.wrapT = THREE.RepeatWrapping;
      specularMap.texture.wrapS = specularMap.texture.wrapT =
        THREE.RepeatWrapping;

      // TERRAIN SHADER

      var terrainShader = THREE.ShaderTerrain['terrain'];

      uniformsTerrain = THREE.UniformsUtils.clone(terrainShader.uniforms);

      uniformsTerrain['tNormal'].value = normalMap.texture;
      uniformsTerrain['uNormalScale'].value = 3.5;

      uniformsTerrain['tDisplacement'].value = heightMap.texture;

      uniformsTerrain['tDiffuse1'].value = diffuseTexture1;
      uniformsTerrain['tDiffuse2'].value = diffuseTexture2;
      uniformsTerrain['tSpecular'].value = specularMap.texture;
      // uniformsTerrain[ 'tDetail' ].value = detailTexture;

      uniformsTerrain['enableDiffuse1'].value = false;
      uniformsTerrain['enableDiffuse2'].value = true; //visitCount >= 3;
      uniformsTerrain['enableSpecular'].value = true;

      uniformsTerrain['diffuse'].value.setHex(0xffffff);
      uniformsTerrain['specular'].value.setHex(0xffffff);

      uniformsTerrain['shininess'].value = 30;

      uniformsTerrain['uDisplacementScale'].value = 1375;

      uniformsTerrain['uRepeatOverlay'].value.set(16, 16);

      var params = [
        [
          'heightmap',
          document.getElementById('fragmentShaderNoise').textContent,
          vertexShader,
          uniformsNoise,
          false,
        ],
        [
          'normal',
          normalShader.fragmentShader,
          normalShader.vertexShader,
          uniformsNormal,
          false,
        ],
        [
          'terrain',
          terrainShader.fragmentShader,
          terrainShader.vertexShader,
          uniformsTerrain,
          true,
        ],
      ];

      for (var i = 0; i < params.length; i++) {
        var material = new THREE.ShaderMaterial({
          uniforms: params[i][3],
          vertexShader: params[i][2],
          fragmentShader: params[i][1],
          lights: params[i][4],
          fog: true,
        });

        mlib[params[i][0]] = material;
      }

      var plane = new THREE.PlaneBufferGeometry(SCREEN_WIDTH, SCREEN_HEIGHT);

      quadTarget = new THREE.Mesh(
        plane,
        new THREE.MeshBasicMaterial({ color: 0x000000 }),
      );
      quadTarget.position.z = -500;
      sceneRenderTarget.add(quadTarget);

      // TERRAIN MESH

      var geometryTerrain = new THREE.PlaneBufferGeometry(6000, 6000, 256, 256);

      THREE.BufferGeometryUtils.computeTangents(geometryTerrain);

      terrain = new THREE.Mesh(geometryTerrain, mlib['terrain']);
      terrain.position.set(0, -125, 0);
      terrain.rotation.x = -Math.PI / 2;
      terrain.visible = false;
      scene.add(terrain);

      // CUBES
      // for (var x=0; x < 10; x++) {
      //   for (var y = 0; y < 10; y++) {
      //     var geometry = new THREE.BoxGeometry( 64, 64, 64 );
      //     var material = new THREE.MeshBasicMaterial( {color: 0x993300} );
      //     var cube = new THREE.Mesh( geometry, material );
      //     cube.position.set((x - 5) * 256, 512, (y - 5) * 256 + 1024);
      //     scene.add( cube );

      //   }
      // }

      // RENDERER

      renderer = new THREE.WebGLRenderer();
      renderer.setPixelRatio(window.devicePixelRatio);
      renderer.setSize(SCREEN_WIDTH, SCREEN_HEIGHT);
      container.appendChild(renderer.domElement);

      // STATS

      // stats = new Stats();
      // container.appendChild( stats.dom );

      // EVENTS

      onWindowResize();

      window.addEventListener('resize', onWindowResize, false);

      // document.addEventListener( 'keydown', onKeyDown, false );
    }

    //

    function onWindowResize(event) {
      SCREEN_WIDTH = window.innerWidth;
      SCREEN_HEIGHT = window.innerHeight - 150;

      renderer.setSize(SCREEN_WIDTH, SCREEN_HEIGHT);

      camera.aspect = SCREEN_WIDTH / SCREEN_HEIGHT;
      camera.updateProjectionMatrix();
    }

    //

    // function onKeyDown(event) {
    //   switch (event.keyCode) {
    //     case 78:
    //       /*N*/ lightDir *= -1;
    //       break;
    //     case 77:
    //       /*M*/ animDeltaDir *= -1;
    //       break;
    //   }
    // }

    //

    function animate() {
      requestAnimationFrame(animate);

      render();
      // stats.update();
      // controls.update();
    }

    function render() {
      var delta = clock.getDelta();

      newScale = newScale + (scale - newScale) * 0.001;

      if (terrain.visible) {
        // var time = Date.now() * 0.001;

        var fLow = 0.1,
          fHigh = 0.8;

        lightVal = THREE.Math.clamp(
          lightVal + 0.5 * delta * lightDir,
          fLow,
          fHigh,
        );

        var valNorm = (lightVal - fLow) / (fHigh - fLow);

        // scene.background.setHSL( 0.1, 0.5, lightVal );
        // scene.fog.color.setHSL( 0.1, 0.5, lightVal );

        directionalLight.intensity = THREE.Math.mapLinear(
          valNorm,
          0,
          1,
          0.1,
          1.15,
        );
        pointLight.intensity = THREE.Math.mapLinear(valNorm, 0, 1, 0.9, 1.5);

        var x = logoSprite.position.x;
        var z = logoSprite.position.z;
        var rotSpeed = 0.002;

        // camera.position.set( -1706.8533148944814, 2143.5675967145926, 1775.015372748465 )

        camera.position.set(0, 2143.5675967145926, 0);
        camera.position.x = x * Math.cos(rotSpeed) + z * Math.sin(rotSpeed);
        camera.position.z = z * Math.sin(rotSpeed) - x * Math.cos(rotSpeed);
        camera.rotation.y += rotSpeed;
        camera.lookAt(logoSprite.position);
        camera.translateZ(1000);

        // uniformsTerrain[ 'uNormalScale' ].value = THREE.Math.mapLinear( valNorm, 0, 1, 0.6, 3.5 );

        if (updateNoise) {
          animDelta = THREE.Math.clamp(
            animDelta + 0.00075 * animDeltaDir,
            0,
            0.025,
          );
          uniformsNoise['time'].value += delta * animDelta;
          // uniformsNoise[ 'scale' ].value = new THREE.Vector2( newScale, newScale );
          uniformsNoise['offset'].value.x += delta * 0.05;

          // uniformsTerrain[ 'uOffset' ].value.x = 4 * uniformsNoise[ 'offset' ].value.x;

          quadTarget.material = mlib['heightmap'];
          renderer.render(sceneRenderTarget, cameraOrtho, heightMap, true);

          quadTarget.material = mlib['normal'];
          renderer.render(sceneRenderTarget, cameraOrtho, normalMap, true);
        }

        renderer.render(scene, camera);
      }
    }

    this.initComplete = true;
  };

  render() {
    const { threeReady } = this.state;
    return (
      <div {...marquee}>
        <div id="container" {...containerRule} />
        <div {...logoWrapper} id="lucastswick-logo">
          <img {...logoRule} src={Logo} alt="Generative Artist Lucas Swick" />
        </div>
        {this.renderFragmentScript()}
        {this.renderVertexScript()}
        {threeReady && this.initThree()}
      </div>
    );
  }
}

export default withCookies(Marquee);



// WEBPACK FOOTER //
// ./src/components/Marquee/Marquee.js